import Axios from "./axios";

const resource = "merchant-shop-plans";

export default {
	get(id) {
		return Axios.get(`${resource}`, {
			params: {
				reseller_id: id
			}
		});
	},
	show(id) {
		return Axios.get(`${resource}/${id}`);
	}
}